var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import Select from "react-select";
import React from "react";
import Async from "react-select/async";
import ReactSelectSimpleValue from "../ReactSelectSimpleValue/ReactSelectSimpleValue";
import { reactSelectStyles } from "../../../../util/reactSelectUtils";
import BootstrapColorService from "../../../Services/Shared/BootstrapColor.service";
const REACT_SELECT_CLASSNAME_PREFIX = "custom-react-select-class";
const getMappedProps = (_a) => {
    var _b;
    var { labelKey, valueKey, value, multi, placeholder, clearable, disabled, style, className, optionRenderer, valueRenderer, defaultOptions, cacheOptions } = _a, others = __rest(_a, ["labelKey", "valueKey", "value", "multi", "placeholder", "clearable", "disabled", "style", "className", "optionRenderer", "valueRenderer", "defaultOptions", "cacheOptions"]);
    const isInvalid = (_b = className === null || className === void 0 ? void 0 : className.split(" ")) === null || _b === void 0 ? void 0 : _b.includes("is-invalid");
    let styles = reactSelectStyles;
    if (isInvalid) {
        styles = Object.assign(Object.assign({}, styles), { control: (provided) => (Object.assign(Object.assign(Object.assign(Object.assign({}, provided), (reactSelectStyles.control
                ? reactSelectStyles.control(provided)
                : {})), style), { borderColor: BootstrapColorService.Danger, "&:focus-within": {
                    boxShadow: "0 0 0 0.2rem rgba(87,81,149, .25)",
                }, "&:hover": {
                    borderColor: BootstrapColorService.Danger,
                } })) });
    }
    else if (style) {
        styles = Object.assign(Object.assign({}, styles), { control: (provided) => (Object.assign(Object.assign(Object.assign({}, provided), (reactSelectStyles.control
                ? reactSelectStyles.control(provided)
                : {})), style)) });
    }
    const mappedProps = Object.assign(Object.assign({}, others), { defaultOptions: defaultOptions !== null && defaultOptions !== void 0 ? defaultOptions : true, cacheOptions: cacheOptions !== null && cacheOptions !== void 0 ? cacheOptions : true, isMulti: multi, isClearable: clearable !== false, isDisabled: disabled, placeholder,
        value,
        className,
        styles });
    if (labelKey) {
        // @ts-expect-error - TS7006 - Parameter 'opt' implicitly has an 'any' type.
        mappedProps.getOptionLabel = (opt) => opt[labelKey];
    }
    if (valueKey) {
        // @ts-expect-error - TS7006 - Parameter 'opt' implicitly has an 'any' type.
        mappedProps.getOptionValue = (opt) => opt[valueKey];
    }
    if (valueRenderer || optionRenderer) {
        // @ts-expect-error - TS7006 - Parameter 'option' implicitly has an 'any' type. | TS7031 - Binding element 'context' implicitly has an 'any' type.
        mappedProps.formatOptionLabel = (option, { context }) => {
            if (context === "value") {
                return valueRenderer
                    ? valueRenderer(option)
                    : mappedProps.getOptionLabel(option);
            }
            return optionRenderer
                ? optionRenderer(option)
                : mappedProps.getOptionLabel(option);
        };
    }
    if (valueRenderer) {
        mappedProps.getOptionLabel = valueRenderer;
    }
    if (optionRenderer) {
        mappedProps.getOptionLabel = optionRenderer;
    }
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type '"aria-label"' can't be used to index type '{}'.
    if (!others["aria-label"]) {
        mappedProps["aria-label"] = mappedProps.placeholder;
    }
    return mappedProps;
};
const DeprecatedSelect = (_a) => {
    var { options } = _a, others = __rest(_a, ["options"]);
    const mappedProps = Object.assign(Object.assign({}, getMappedProps(others)), { options });
    let isSimpleValue = false;
    const simpleTypes = ["string", "number"];
    if (Array.isArray(mappedProps.value)) {
        if (mappedProps.value[0] &&
            simpleTypes.includes(typeof mappedProps.value[0])) {
            isSimpleValue = true;
        }
    }
    else {
        isSimpleValue = simpleTypes.includes(typeof mappedProps.value);
    }
    // If value is a simple string or number, assume that it's a key / reference to the actual value.
    if (isSimpleValue) {
        return (
        // @ts-expect-error - TS2786 - 'ReactSelectSimpleValue' cannot be used as a JSX component.
        _jsx(ReactSelectSimpleValue, Object.assign({}, mappedProps, { children: (provided) => (_jsx(Select, Object.assign({ classNamePrefix: REACT_SELECT_CLASSNAME_PREFIX }, provided))) })));
    }
    return (_jsx(Select, Object.assign({ classNamePrefix: REACT_SELECT_CLASSNAME_PREFIX }, mappedProps)));
};
const DeprecatedAsync = (_a) => {
    var { loadOptions } = _a, others = __rest(_a, ["loadOptions"]);
    const mappedProps = Object.assign(Object.assign({}, getMappedProps(others)), { loadOptions: (search) => loadOptions(search).then(({ options }) => options) });
    // If value is a simple string or number, assume that it's a key / reference to the actual value.
    if (mappedProps.value === null ||
        ["string", "number"].includes(typeof mappedProps.value)) {
        return (
        // @ts-expect-error - TS2786 - 'ReactSelectSimpleValue' cannot be used as a JSX component.
        _jsx(ReactSelectSimpleValue, Object.assign({}, mappedProps, { children: (provided) => (_jsx(Async, Object.assign({ classNamePrefix: REACT_SELECT_CLASSNAME_PREFIX }, provided))) })));
    }
    return (_jsx(Async, Object.assign({ classNamePrefix: REACT_SELECT_CLASSNAME_PREFIX }, mappedProps)));
};
DeprecatedSelect.Async = DeprecatedAsync;
export default DeprecatedSelect;
